import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rolesData: [],
};

const RolesSlice = createSlice({
  name: "RolesSlice",
  initialState,
  reducers: {
    setRolesData: (state, action) => {
      state.rolesData = action.payload;
    },
  },
});
export const { setRolesData } = RolesSlice.actions;

export default RolesSlice.reducer;
